import { makeAutoObservable } from "mobx";
import { SnackbarMessage, OptionsObject, SnackbarAction, SnackbarKey } from "notistack";

export interface NotifierParams {
  message: SnackbarMessage;
  options?: OptionsObject;
  action?: (closeSnackbar: (key?: SnackbarKey) => void) => SnackbarAction;
}

class UiStore {
  private pendingRequestCount = 0;

  notifier: NotifierParams = {
    message: "",
  };

  constructor() {
    makeAutoObservable(this);
  }

  startPending = () => {
    this.pendingRequestCount += 1;
  };

  stopPending = () => {
    this.pendingRequestCount -= 1;
  };

  notify = (data: NotifierParams) => {
    this.notifier = data;
  };

  get loading() {
    return this.pendingRequestCount > 0;
  }
}

export const uiStore = new UiStore();
